import { Button } from "@/components/ui/button";
import { cn } from "@/utils/cn";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { ChevronDown, FileSignature } from "lucide-react";
import { useEffect, useRef, useState } from "react";

export const Route = createFileRoute("/preview/consent")({
	component: ConsentLayout,
});

function ConsentLayout() {
	const contentRef = useRef<HTMLDivElement>(null);
	const [showScrollButton, setShowScrollButton] = useState(true);

	useEffect(() => {
		const checkScrollPosition = () => {
			if (!contentRef.current) return;

			const { scrollTop, scrollHeight, clientHeight } =
				document.documentElement;

			// Hide the button when we're past the halfway point of the page
			const isPastHalfway = scrollTop + clientHeight >= (scrollHeight * 7) / 8;
			setShowScrollButton(!isPastHalfway);
		};

		window.addEventListener("scroll", checkScrollPosition);
		checkScrollPosition();

		return () => window.removeEventListener("scroll", checkScrollPosition);
	}, []);

	const scrollToSignature = () => {
		const signatureElement = document.getElementById("consent-signature");
		if (signatureElement) {
			signatureElement.scrollIntoView({ behavior: "smooth" });
		} else {
			// Fallback to bottom of page if element not found
			window.scrollTo({
				top: document.documentElement.scrollHeight,
				behavior: "smooth",
			});
		}
	};

	return (
		<div
			ref={contentRef}
			className={cn("prose prose-h2:mt-4", "mx-auto max-w-5xl relative")}
		>
			<Outlet />
			<div id="consent-signature" />
			{showScrollButton && (
				<div className="bottom-8 left-1/2 fixed px-4 max-w-md -translate-x-1/2">
					<Button
						variant="secondary"
						className={cn(
							"shadow-md rounded-lg",
							"transition-all duration-300 hover:translate-y-1",
							"flex items-center justify-center gap-2",
							"px-4 py-2",
						)}
						onClick={scrollToSignature}
						aria-label="Scroll to signature section"
					>
						<span>Go to signature</span>
						<ChevronDown className="w-5 h-5" />
					</Button>
				</div>
			)}
		</div>
	);
}
